import { render, staticRenderFns } from "./manufacturer.vue?vue&type=template&id=0098824b&"
import script from "./manufacturer.vue?vue&type=script&lang=js&"
export * from "./manufacturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0098824b')) {
      api.createRecord('0098824b', component.options)
    } else {
      api.reload('0098824b', component.options)
    }
    module.hot.accept("./manufacturer.vue?vue&type=template&id=0098824b&", function () {
      api.rerender('0098824b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/data-dictionary/manufacturer/manufacturer.vue"
export default component.exports